import { Input, ITranslateInputProps } from 'legacy/lut/library/inputs'
import { ValidateInput } from 'legacy/lut/library/validation'
import React, { useCallback } from 'react'

import { IForm } from 'core-components/classes/models/IForm'
import {
  MultiSelect as CoreMultiSelect,
  IMultiselectProps as IMultiselectCoreProps,
} from 'core-components/library/multiSelect'

interface IMultiselectProps<T = IForm, R = string | number> extends IMultiselectCoreProps<T, R> {
  translation?: string
}

export function MultiSelect<T = IForm, R = string | number>(props: IMultiselectProps<T, R>) {
  const prepareConfig = useCallback(
    (config: ITranslateInputProps) => {
      config.translation = props.translation
    },
    [props.translation]
  )
  return (
    <CoreMultiSelect
      {...props}
      prepareInputConfig={prepareConfig}
      ValidateInputComponent={ValidateInput}
      InputComponent={Input}
    />
  )
}
